export default "__VITE_ASSET__9231e1d6__"